/*
 * This file is generated by generate_bundler_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {OfferListMapView} from "../../offer/views/OfferListMapView";
const route = [
    {
        bundlerEntry: "offerListMap",
        path: [
            rpAppPath.friendlyOfferListAbroadCountryMap,
            rpAppPath.friendlyOfferListAbroadRegionMap,
            rpAppPath.offer.map,
            rpAppPath.friendlyOfferListMap.base,
            rpAppPath.friendlyOfferListMap.subType,
            rpAppPath.multiOfferList.map
        ],
        component: OfferListMapView
    }
];

(function () {
    rpClient(route);
})();
/*
 * This file is generated by generate_bundler_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {OfferListMapView} from "../../offer/views/OfferListMapView";
const route = [
    {
        bundlerEntry: "offerListMap",
        path: [
            rpAppPath.friendlyOfferListAbroadCountryMap,
            rpAppPath.friendlyOfferListAbroadRegionMap,
            rpAppPath.offer.map,
            rpAppPath.friendlyOfferListMap.base,
            rpAppPath.friendlyOfferListMap.subType,
            rpAppPath.multiOfferList.map
        ],
        component: OfferListMapView
    }
];

(function () {
    rpClient(route);
})();
